import React from 'react';
import { connect } from 'react-redux';
import { updateUserLocal, setAgencySegment } from 'common/ducks/user';
import { CREATIVE_REGISTRATION_CLOSED } from 'registration/constants';
import { redeemInvite } from 'registration/creative/ducks';
import Step1 from 'registration/common/components/step1'

const mapStateToProps = ({ user, creativeRegistration: { inviteHash, inviteRedeemed } }) => ({
  user,
  inviteHash,
  inviteRedeemed,
  creativeRegistrationClosed: CREATIVE_REGISTRATION_CLOSED && !inviteHash
})

export default connect(mapStateToProps, {
  updateUserLocal,
  setAgencySegment,
  redeemInvite
})(Step1);



// WEBPACK FOOTER //
// ./registration/common/containers/step1.jsx